import AllDecompsDataDownload from './AllDecompsDataDownload';
export default AllDecompsDataDownload;
